module.exports = __webpack_public_path__ + "static/media/icon_hethong_capphep.ca6c8763.svg";